/**
 * Formats a raw digit string to MM:SS format
 * Examples:
 * - "4523" -> "45:23"
 * - "525" -> "5:25"
 * - "15" -> "0:15"
 * - "5" -> "0:05"
 * - "4560" -> "45:59" (seconds capped at 59)
 */
export function formatDuration(input: string): string {
  const digits = input.replace(/\D/g, '');

  if (!digits) return '';

  const limitedDigits = digits.slice(0, 4);
  const padded = limitedDigits.padStart(2, '0');

  let minutes: string;
  let seconds: string;

  if (padded.length <= 2) {
    minutes = '0';
    seconds = padded;
  } else if (padded.length === 3) {
    minutes = padded[0];
    seconds = padded.slice(1);
  } else {
    minutes = padded.slice(0, 2);
    seconds = padded.slice(2);
  }

  const secondsNum = parseInt(seconds, 10);
  if (secondsNum > 59) {
    seconds = '59';
  }

  return `${minutes}:${seconds}`;
}

/**
 * Extracts raw digits from a formatted duration, removing leading zero from minutes
 * "0:15" -> "15", "5:30" -> "530", "45:23" -> "4523"
 */
export function extractRawDigits(formatted: string): string {
  if (!formatted) return '';
  const parts = formatted.split(':');
  if (parts.length !== 2) return formatted.replace(/\D/g, '');

  const minutes = parts[0].replace(/^0+/, '') || '';
  const seconds = parts[1];
  return minutes + seconds;
}
